import PageTitle from '@components/PageTitle'
import WithPortalAuthorization from '@hocs/WithPortalAuthorization'
import Dashboard from '@layouts/Dashboard/Layout'
import React from 'react'

const InstructorDashboard: React.FunctionComponent = () => (
  <>
    <PageTitle title={'Instructor dashboard'} />
    <Dashboard />
  </>
)

export default WithPortalAuthorization(InstructorDashboard, {
  id: 'page::dashboard::instructor',
})
